import './TableRowText.scss';

export interface ITableRowTextProps {
  isSupplementary?: boolean;
  text?: string;
  emptyText?: string;
  justifyPosition?: string;
  className?: string;
  title?: string;
  onClick?: () => void;
}

const TableRowText = ({
  isSupplementary = false,
  text,
  emptyText = '-',
  justifyPosition = 'start',
  title,
  className = '',
  onClick,
}: ITableRowTextProps) => {
  const itemText = text?.length ? text : emptyText;

  return (
    <div
      className={`table-row-item-text flex ${className} ${
        isSupplementary ? ' supplementary' : ''
      }`}
      onClick={onClick}
      title={title ?? itemText}>
      {itemText}
    </div>
  );
};

export default TableRowText;
